import FormClientes from '../componentes/FormClientes.vue'
import ListaClientes from '../componentes/ListaClientes.vue'
import HistorialCliente from '../componentes/HistorialCliente.vue'
import EstadisticasCliente from '../componentes/EstadisticasCliente.vue'
import InformeGeneral from '../componentes/InformeGeneral.vue'


const routes = [
    ...route('/guardar-potencial', FormClientes, {
        rol : [1,2],
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-potenciales', ListaClientes, {
       Auth: true,
       rol : [1,2],

       //req_admin: true
    }),
    ...route('/guardar-cliente', FormClientes, {
      rol : 2,
      Auth: true,
      ///req_admin: true
   }),
   ...route('/lista-clientes', ListaClientes, {
     Auth: true,
     rol : 2,
     //req_admin: true
  }),
    ...route('/historial-cliente', HistorialCliente, {
        Auth: true,
        //req_admin: true
     }),
     ...route('/estadistica-cliente', EstadisticasCliente, {
        Auth: true,
        //req_admin: true
     }),
     ...route('/informe-general', InformeGeneral, {
      Auth: true,
       rol : [1,2],
       //req_admin: true
   }),

]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes